<template>
  <div class="sky-poc-project-detail">
    <div class="sky-poc-project-detail__title">
      <div class="title-content">
        <div class="customer attr-item attr-ellipsis">
          【{{ industryMap[industryId] }}】当前客户：{{ detail.customer }}
        </div>
      </div>
      <div class="wsp-margin-left-12">
        <div :class="` ${!uplaodStatus ? 'bg-3bb113 el-icon-upload' : 'color-E69D01 el-icon-loading '}`">
          {{ !uplaodStatus ? '变更已保存' : '变更保存中' }}
        </div>
      </div>
    </div>

    <div class="sky-poc-project-detail__content">
      <div class="content-progress">
        <custom-step
          :steps="progressSteps"
          :activityStep="{ main: mainStep, children: childStep }"
          @changeMenu="changeMenu"
        ></custom-step>
      </div>
      <div class="stage-view-content">
        <!-- <div class="content-step-progress">
          <div class="content-step-content">
            <el-steps :active="businessStep" simple>
              <el-step v-for="(childItem, key) in businessSetpView" :key="key" :title="childItem.name"> </el-step>
            </el-steps>
          </div>
        </div> -->

        <component-view
          :data="{
            projectId: projectId,
            stage: stage,
            industryId: industryId,
            industryCode: industryCode,
            customer: detail.customer,
            createBytmp: createBytmp,
            createByTmpNotBackToFirstStep: createByTmpNotBackToFirstStep
          }"
          :ref="activiteViewPage.component"
          :name="activiteViewPage.component"
          :viewComponent="activiteViewPage.component"
          @handelToAutoNext="handelToAutoNext"
          @changeProjectId="changeProjectId"
          @restartInterval="restartInterval"
          @changeStage="changeStage"
          @showBtns="showBtns"
          @openChangeDialog="openChangeDialog"
          :key="componentKey"
        ></component-view>
      </div>
    </div>

    <div class="sky-poc-project-detail__toolbar">
      <div class="toolbar-title bg-red el-icon-info" v-if="hasSave">
        <span>"保存更改"：仅保存本步骤修改内容，不跳转步骤</span>
      </div>
      <div class="toolbar-title bg-red el-icon-info" v-if="showGuide">
        <span>查看或修改其它步骤数据可点击上方【步骤标签】直接跳转</span>
      </div>
      <div class="toolbar-content">
        <div class="toolbar-btns">
          <el-button
            class="toolbar-btns-item "
            type="info"
            icon="sk-icon-home"
            @click="gotoHomePocProjectList"
            size="mini"
            >我的项目</el-button
          >

          <el-tooltip
            class="item"
            effect="dark"
            content="查看或修改其它步骤数据可点击上方【步骤】标签直接跳转"
            placement="top"
          >
            <el-button
              class="toolbar-btns-item "
              icon="el-icon-arrow-left"
              v-if="preNext"
              @click="gotoPreStep"
              size="mini"
              >上一步</el-button
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="查看或修改其它步骤数据可点击上方【步骤】标签直接跳转"
            placement="top"
          >
            <el-button
              class="toolbar-btns-item "
              :loading="loadingNext"
              @click="gotoNextStep"
              :disabled="saveIng || uplaodStatus"
              v-if="hasNext"
              size="mini"
              >下一步<i class="el-icon-arrow-right el-icon--right"></i
            ></el-button>
          </el-tooltip>
          <el-button
            class="toolbar-btns-item sk-icon-save "
            icon="el-icon-save"
            :disabled="saveIng || uplaodStatus"
            @click="saveStep"
            v-if="hasSave"
            size="mini"
            type="success"
            >保存更改</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Steps, Step, Button, Tooltip } from 'element-ui'
import { action } from 'sky-engine/api/index'

import componentView from './component'
import ChangeDetail from './metadata/common/ChangeDetail'
import customStep from './step/index'

import { POC_MNG } from '@/api/apiModules'
import { updateFlowStatus, getDetail, saveTempStepData, getProjectMonitorChangeDetail } from '@/api/project'
import { getIndustryList, getSystemSpecEditState } from '@/api/setting'

export default {
  name: 'SkyPocProjectDetailContent',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    customStep,
    componentView
  },
  props: {
    projectId: {
      type: String,
      default: () => {
        return null
      }
    },
    customer: {
      type: String
    },
    industryId: {
      type: String
    },
    industryCode: {
      type: String
    },
    createBytmp: {
      type: Boolean
    },
    createByTmpNotBackToFirstStep: {
      type: Boolean
    },
    stage: {
      type: String,
      default: () => {
        return 'MDR_PROJECT_INIT'
      }
    }
  },
  computed: {},
  created() {
    this.queryProjectDetail()
    if (this.industryCode === 'YYS') {
      this.progressSteps[0].children[1].component = 'StepViewCreateOrederIndustry'
    }
    for (let index = 0; index < this.progressSteps.length; index++) {
      const main = this.progressSteps[index]
      for (let y = 0; y < main.children.length; y++) {
        const children = main.children[y]

        if (children.childStage.includes(this.stage)) {
          this.mainStep = index
          main.status = 'inprogess'
          this.childStep = y
          children.status = 'inprogess'
          break
        } else {
          children.status = 'done'
          main.status = 'done'
        }
      }
    }
    this.activiteViewPage = this.progressSteps[this.mainStep].children[this.childStep]

    if (
      this.mainStep === this.progressSteps.length - 1 &&
      this.childStep == this.progressSteps[this.mainStep].children.length - 1
    ) {
      this.hasNext = false
      this.progressSteps[this.mainStep].status = 'done'
      this.progressSteps[this.mainStep].children[this.childStep].status = 'done'
    } else {
      this.progressSteps[this.mainStep].status = 'inprogess'
      this.progressSteps[this.mainStep].children[this.childStep].status = 'inprogess'
    }

    this.startInterval()
  },
  beforeDestroy() {
    this.stopInterval()
  },
  data() {
    return {
      componentKey: 0,
      activiteViewPage: null,
      viewIsPreStep: false,
      uplaodStatus: false,
      saveIng: false,
      mainStep: 0,
      loadingNext: false,
      timer: null,
      childStep: 0,
      hasNext: true,
      preNext: true,
      hasSave: false,
      showGuide: false,
      activiteStage: null,
      detail: {},
      industryMap: {},
      progressSteps: [
        {
          name: '需求调研阶段',
          status: 'todo',
          children: [
            {
              name: '需求调研',
              status: 'todo',
              component: 'SkyStepViewDemandSurvey',
              childStage: [
                'MDR_PROJECT_INIT',
                'MDR_SCENE_RESEARCH',
                'MDR_SCENE_COLLECT',
                'MDR_PROJECT_ENV',
                'MDR_TEST_CASE'
              ]
            },
            {
              name: '创建工单-样机',
              status: 'todo',
              component: 'StepViewCreateOreder',
              childStage: ['CREATE_ORDER']
            }
            // {
            //   name: '资源确认-样机',
            //   status: 'todo',
            //   component: 'SkyStepViewDefault'
            // },
            // {
            //   name: '初步评审-线下',
            //   status: 'todo',
            //   component: 'SkyStepViewDefault'
            // }
          ]
        }
        // {
        //   name: '测试准备阶段',
        //   metedata: '数据参数',
        //   status: 'todo',
        //   children: [
        //     {
        //       name: '测试准备1',
        //       status: 'todo',
        //       component: 'SkyStepViewDefault'
        //     }
        //   ]
        // },
        // {
        //   name: '测试实施阶段',
        //   metedata: '数据参数',
        //   status: 'todo',
        //   children: [
        //     {
        //       name: '测试实施1',
        //       status: 'todo',
        //       component: 'SkyStepViewDefault'
        //     }
        //   ]
        // },
        // {
        //   status: 'todo',
        //   name: '测试收尾阶段',
        //   metedata: '数据参数',
        //   children: [
        //     {
        //       name: '测试收尾1',
        //       status: 'todo',
        //       component: 'SkyStepViewDefault'
        //     }
        //   ]
        // }
      ]
    }
  },
  mounted() {},
  destroyed() {
    this.activiteViewPage = null
  },
  methods: {
    startInterval() {
      console.log('开始定时器')
      this.timer = setInterval(() => {
        this.saveStepTempData()
      }, 10000)
    },
    stopInterval() {
      console.log('停止计时器')
      if (this.timer != null) {
        clearInterval(this.timer)
      }
    },
    restartInterval() {
      this.stopInterval()
      this.startInterval()
    },
    reloadData() {
      //重新加载数据
      this.componentKey = this.componentKey + 1
    },
    async openChangeDialog(param) {
      var hasChange = false
      await getProjectMonitorChangeDetail({ id: param.projectId }).then(res => {
        if (!res.data.content) {
          return
        }
        hasChange = true
        var dialog = this.$dialog({
          template: h => {
            const projectId = this.projectId
            return (
              <change-detail
                projectId={projectId}
                onCb={function() {
                  dialog.remove()
                  dialog.component.$parent.$parent.reloadData()
                }}
              ></change-detail>
            )
          },
          components: {
            ChangeDetail
          },
          props: {
            title: '项目【' + this.customer + '】变更详情',
            width: '75%',
            'custom-class': 'custom-change-detail-dialog',
            showCancelBtn: false, // 隐藏取消按钮
            showClose: false, // 隐藏关闭按钮
            showDefaultFooter: false, //隐藏确定和取消按钮
            closeOnPressEscape: false, // 不能通过ESC键关闭
            closeOnHashChange: false // 不能通过路由改变关闭
          }
        })
      })
      return hasChange
    },
    showBtns(params) {
      this.hasNext = params.nextStep
      this.preNext = params.preStep
      this.hasSave = params.saveStep
      this.showGuide = !params.saveStep && !params.preStep
    },
    handelToAutoNext() {
      this.gotoNextStep()
    },
    changeProjectId(params) {
      this.projectId = params.projectId
      this.detail.customer = params.customer
      this.industryId = params.industryId
      this.industryCode = params.industryCode
      this.customer = params.customer
    },
    changeStage(params) {
      this.stage = params
    },
    changeViewIsPreStep(params) {
      this.viewIsPreStep = params
    },
    queryProjectDetail() {
      getIndustryList({}).then(res => {
        var codeMap = {}
        res.data.content.itemArr.forEach(element => {
          this.industryMap[element.id] = element.industryName
          codeMap[element.id] = element
        })

        if (this.projectId) {
          getDetail({ id: this.projectId }).then(res => {
            this.detail = res.data.content
            this.industryId = this.detail.industryId

            this.industryCode = codeMap[this.industryId].industryCode
          })
        }
      })
    },
    gotoHomePocProjectList() {
      action(POC_MNG, 'deleteLock')
        .then(response => {})
        .catch(e => {
          throw e
        })
      this.activiteViewPage = null
      this.$store.dispatch('ReturnPage')
    },
    saveStepTempData() {
      let refContent = this.activiteViewPage.component
      var data = this.$refs[refContent].$children[0].getData()

      if (data.dataChange) {
        let req_params = {
          projectId: this.projectId,
          flowStep: data.flowStep,
          data: data.busData
        }
        this.uplaodStatus = true
        saveTempStepData(req_params).then(res => {
          this.uplaodStatus = false
          this.$store.dispatch('OpenNotification', {
            message: '变更信息已暂存',
            type: 'success'
          })
        })
      } else {
        console.log('无需保存')
      }
    },
    async saveStep() {
      let refContent = this.activiteViewPage.component
      var hasChange = await this.openChangeDialog({ projectId: this.projectId })
      if (hasChange) {
        return
      }
      this.saveIng = !this.saveIng

      this.$refs[refContent].$children[0].saveStep().then(result => {
        this.saveIng = !this.saveIng
        if (this.createBytmp && this.stage === 'MDR_TEST_CASE') {
          this.$store
            .dispatch('OpenConfirm', {
              title: '提示',
              message:
                '1.当前步骤信息已保存成功！</br>&nbsp;&nbsp;&nbsp;您可以直接生成测试方案。</br>2.如果您选择继续完善项目信息</br>&nbsp;&nbsp;&nbsp;可切换“步骤”标签进行查看以编辑其它信息。',
              showCancelButton: true,
              confirmText: '直接生成测试方案',
              cancelText: '继续完善项目信息',
              option: {
                showIcon: true,
                type: 'info',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                dangerouslyUseHTMLString: true
              }
            })
            .then(btnAction => {
              this.gotoPageView(0, 1)
            })
            .catch(btnAction => {})
          return null
        } else {
          var stepData = this.$refs[refContent].$children[0].getData()
          this.$store
            .dispatch('OpenConfirm', {
              title: '提示',
              message:
                '1.当前步骤信息已保存，您可以选择继续未完成步骤。</br>2.如果您选择留在本步骤，可通过切换“步骤”标签进行查看以编辑其它步骤信息。',
              showCancelButton: true,
              confirmText: '继续未完成步骤',
              cancelText: '留在本步骤',
              option: {
                showIcon: true,
                type: 'info',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                dangerouslyUseHTMLString: true
              }
            })
            .then(btnAction => {
              this.$refs[refContent].$children[0].handelNavItem(stepData.flowStage.item, stepData.flowStage.index)
            })
            .catch(btnAction => {})
        }
        if (!result) {
          return null
        }
      })
    },
    gotoPageView(mainStepIndex, childStepIndex) {
      let processParams = {
        main: mainStepIndex,
        children: childStepIndex
      }
      updateFlowStatus({
        projectId: this.projectId,
        flowStatus: this.progressSteps[processParams.main].children[processParams.children].childStage[0]
      }).then(res => {})

      if (
        processParams.main === this.progressSteps.length - 1 &&
        processParams.children == this.progressSteps[processParams.main].children.length - 1
      ) {
        this.hasNext = false
        this.progressSteps[processParams.main].status = 'done'
        this.progressSteps[processParams.main].children[processParams.children].status = 'done'
      } else {
        this.progressSteps[this.mainStep].status = 'inprogess'
        this.progressSteps[this.mainStep].children[this.childStep].status = 'inprogess'
      }
      this.changeMenu(processParams)
    },
    async gotoNextStep(status) {
      let refContent = this.activiteViewPage.component
      if (this.projectId) {
        var hasChange = await this.openChangeDialog({ projectId: this.projectId })

        if (hasChange) {
          return
        }
      }
      this.loadingNext = true
      this.$refs[refContent].$children[0]
        .gotoNextStep()
        .then(result => {
          this.loadingNext = false
          if (!result) {
            return
          }
          if (this.industryCode === 'YYS') {
            this.progressSteps[0].children[1].component = 'StepViewCreateOrederIndustry'
          }

          let processParams = {
            main: this.mainStep,
            children: this.childStep
          }
          let childStep = this.progressSteps[this.mainStep].children
          if (this.childStep < childStep.length - 1) {
            this.progressSteps[this.mainStep].children[this.childStep].status = 'done'
            processParams.children += 1
          } else if ((this.childStep = childStep.length - 1)) {
            processParams.main += 1
            processParams.children = 0
          }
          updateFlowStatus({
            projectId: this.projectId,
            flowStatus: this.progressSteps[processParams.main].children[processParams.children].childStage[0]
          }).then(res => {})
          if (
            processParams.main === this.progressSteps.length - 1 &&
            processParams.children == this.progressSteps[processParams.main].children.length - 1
          ) {
            this.hasNext = false
            this.progressSteps[processParams.main].status = 'done'
            this.progressSteps[processParams.main].children[processParams.children].status = 'done'
          } else {
            this.progressSteps[this.mainStep].status = 'inprogess'
            this.progressSteps[this.mainStep].children[this.childStep].status = 'inprogess'
          }
          this.changeMenu(processParams)
        })
        .catch(err => {})
    },
    async gotoPreStep() {
      var state = false

      if (this.createByTmpForCreateOrder) {
        this.createByTmpForCreateOrder = false
      }
      await getSystemSpecEditState().then(res => {
        if (res.data.content.maintenanceState) {
          this.$store.dispatch('OpenNotification', {
            message: res.data.content.message,
            type: 'error'
          })
          state = true
          return
        }
      })
      if (state) {
        return
      }

      var hasChange = await this.openChangeDialog({ projectId: this.projectId })

      console.log(hasChange)
      if (hasChange) {
        return
      }
      this.hasNext = true
      let refContent = this.activiteViewPage.component
      let enablePrev = this.$refs[refContent].$children[0].gotoPreStep()
      if (!enablePrev) {
        return
      }
      let processParams = {
        main: this.mainStep,
        children: this.childStep
      }
      if (processParams.children > 0) {
        this.progressSteps[this.mainStep].children[this.childStep].status = 'todo'
        processParams.children--
      } else {
        this.progressSteps[this.mainStep].children[this.childStep].status = 'todo'
        this.progressSteps[this.mainStep].status = 'todo'
        processParams.main--
        processParams.child = 0
      }

      var gotoView = this.progressSteps[processParams.main].children[processParams.children]

      if (this.industryCode === 'YYS') {
        this.stage = gotoView.childStage[0]
        updateFlowStatus({
          projectId: this.projectId,
          flowStatus: gotoView.childStage[0]
        }).then(res => {})
      } else {
        this.stage = gotoView.childStage[gotoView.childStage.length - 1]
        updateFlowStatus({
          projectId: this.projectId,
          flowStatus: gotoView.childStage[gotoView.childStage.length - 1]
        }).then(res => {})
      }

      // updateFlowStatus({
      //   projectId: this.projectId,
      //   flowStatus: gotoView.childStage[gotoView.childStage.length - 1]
      // }).then(res => {})

      // this.stage = gotoView.childStage[gotoView.childStage.length - 1]
      this.progressSteps[processParams.main].status = 'inprogess'
      this.progressSteps[processParams.main].children[processParams.children].status = 'inprogess'
      this.changeMenu(processParams)
    },
    changeProgessData() {},
    changeMenu(params) {
      this.mainStep = params.main
      if (params.children) {
        this.childStep = params.children
      } else {
        this.childStep = 0
      }

      this.activiteViewPage = this.progressSteps[this.mainStep].children[this.childStep]
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(poc-project-detail) {
  height: 100%;
  @include e(title) {
    height: 36px;
    z-index: 2;
    width: 680px;
    position: absolute;
    .title-content {
      line-height: 33px;
      font-size: 18px;
      padding: 0 6px;
      margin: 12px 6px;
      display: flex;
      background: linear-gradient(to right, #ebebeb, #fff);
      .attr-item {
        padding: 0 3px;
      }
      .attr-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  @include e(content) {
    height: 90%;
    display: flex;
    .content-progress {
      margin-top: 48px;
      padding: 8px 18px;
      width: 12%;
      height: 80vh;
    }
    .stage-view-content {
      width: 88%;
      height: 100%;
      .content-step-progress {
        height: 36px;
        .content-step-content {
          float: right;
          width: 70%;
          .el-steps--simple {
            padding: 6px 12px !important;
          }
        }
      }
    }
  }
  @include e(toolbar) {
    .toolbar-title {
      position: absolute;
      padding-top: 6px;
      font-size: 14px;
      left: 50%;
      transform: translateX(-50%);
    }
    .toolbar-content {
      box-shadow: 0 0 12px 0 rgb(24 44 108 / 15%);
      height: 88px;
      justify-content: center;
      align-items: center;
      display: flex;
      .toolbar-btns {
        .toolbar-btns-item {
          margin-right: 12px;
        }
      }
    }
  }
}
</style>
